export default "__VITE_ASSET__BJR51x7q__"